<template>
    <div></div>
</template>

<script>
export default {
    mounted() {
        $('.flexSidebar').hide()
    }
}
</script>
